import { render, staticRenderFns } from "./userInfoDc.vue?vue&type=template&id=2717943e&scoped=true"
import script from "./userInfoDc.vue?vue&type=script&lang=js"
export * from "./userInfoDc.vue?vue&type=script&lang=js"
import style0 from "./userInfoDc.vue?vue&type=style&index=0&id=2717943e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2717943e",
  null
  
)

export default component.exports